import React from 'react';
import { MessageType } from '@amityco/js-sdk';
import Deleted from './Deleted';
import Text from './Text';
import Custom from './Custom';
import Unsupported from './Unsupported';
const RENDERERS = {
    [MessageType.Text]: Text,
    [MessageType.Custom]: Custom,
};
const MessageContent = ({ data, type, isDeleted }) => {
    var _a;
    if (isDeleted) {
        return React.createElement(Deleted, null);
    }
    const Renderer = (_a = RENDERERS[type]) !== null && _a !== void 0 ? _a : Unsupported;
    return React.createElement(Renderer, { data: data });
};
export default MessageContent;
//# sourceMappingURL=index.js.map